import { DeleteVideos } from '@/connection/content/videos';
import { RootState } from '@/store/main';
import { ContentReducerCreator, ContentState } from '../types';
import { cannotDeleteToast } from '../utils';

const deleteUploadedVideoReducer = (create: ContentReducerCreator) => {
  return create.asyncThunk(
    async (channel: number, { getState }) => {
      const state = (getState() as RootState).content as ContentState;
      return await DeleteVideos(channel, Object.keys(state.contentMarkedForDeletion));
    },
    {
      fulfilled: (state, action) => {
        if (action.payload.cannotDelete.length) {
          const cannotDeleteSet = new Set(action.payload.cannotDelete || []);

          const errorMessage =
            state.uploadedVideos
              ?.filter((video) => cannotDeleteSet.has(video.uuid))
              .map((video) => video.name)
              .join(', ') || '';
          cannotDeleteToast(errorMessage);
        }

        if (state.uploadedVideos) {
          state.uploadedVideos = state.uploadedVideos.filter(
            (uploadedVid) => !action.payload.videoIDs.includes(uploadedVid.uuid)
          );
          state.contentMarkedForDeletion = {};
        }
      },
    }
  );
};

export default deleteUploadedVideoReducer;
